export interface SelectFileModel {
  name: string;
  displaySize?: string;
  url?: string;
  file?: File;
  uploadResponse?: any;
}
